import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncDropdown } from 'src/app/models/async-dropdown';
import { SortObject } from 'src/app/models/sortObject';
import { LovApiService } from 'src/app/services/lov-api.service';
import { LoadingService } from 'src/app/services/shared/loading.service';
import { ToastService } from 'src/app/services/toast.service';
import { BudgetsService } from '../service/budgets.service';
import { BatchSummaryComponent } from './batch-summary/batch-summary.component';
import { BudgetUpdateModel } from './models/budget-update';
import { BudgetService } from './service/budget.service';
@Component({
    selector: 'njo-batch-budget-edit',
    templateUrl: './batch-budget-edit.component.html',
    styleUrls: ['./batch-budget-edit.component.scss'],
    providers: [BudgetService],
    standalone: false
})
export class BatchBudgetEditComponent {
  public form: UntypedFormGroup = null;
  @Input() selectedRows: Array<string> = [];

  // dropdowns
  public type: AsyncDropdown[] = [];
  public typeLoading: boolean = false;
  public department: AsyncDropdown[] = [];
  public departmentLoading: boolean = false;

  tags: Array<string> = [];
  tagsSuggestion: Array<string> = [];
  errors = [];
  successes = [];
  disableForm: boolean = true;

  constructor(
    private readonly modalService: NgbModal,
    private readonly budgetService: BudgetService,
    private readonly toastService: ToastService,
    private readonly lovApiService: LovApiService,
    private readonly loadingService: LoadingService,
    private readonly budgetsDashboardService: BudgetsService
  ) {
    this.initSingleForm();
  }

  initSingleForm() {
    this.initDropdowns();
    this.form = new UntypedFormGroup({
      type: new UntypedFormControl(),
      department: new UntypedFormControl(),
      jobCode: new UntypedFormControl(),
      tags: new UntypedFormControl(),
    });
  }

  initDropdowns() {
    this.tags = [];
    this.type.push(new AsyncDropdown());
  }

  open(content) {
    this.form.reset();
    this.errors = [];
    this.successes = [];
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {},
      (reason) => {
        this.initSingleForm();
      }
    );
  }

  close() {
    this.initSingleForm();
    this.modalService.dismissAll();
  }

  async bulkUpdateOrders(e) {
    for (let i = 0; i < this.selectedRows.length; i++) {
      this.toastService.showInfo("Updating budget number " + Number(i + 1));
      if(i == 0) {
        this.loadingService.pushLoadingRequests('any');
      }
      if (i !== 0) await new Promise((r) => setTimeout(r, 2000));
      this.budgetService
        .bulkUpdateBudget(
          Object.assign(new BudgetUpdateModel(), {
            identifier: this.selectedRows[i],
            type: this.form.value.type,
            department: this.form.value.department,
            jobCode: this.form.value.jobCode,
            tags: this.tags,
          })
        )
        .then(
          (response) => {
            this.successes.push(response);
          },
          (err) => {
            this.loadingService.pushLoadingRequests('any');

            this.errors.push(err);
          }
        )
        .finally(() => {
          if (i === this.selectedRows.length - 1 && this.successes.length === this.selectedRows.length) {
            this.loadingService.popLoadingRequests();
            this.close();
            this.budgetsDashboardService.fetchBudgetsDashboard(true);
            this.toastService.showSuccess('Operation Success! ' + this.successes.length + ' budget(s) updated!');
            this.selectedRows = [];
          }
          if (i === this.selectedRows.length - 1 && this.errors.length > 0) {
            this.loadingService.popLoadingRequests();
            this.close();
            const modalRef = this.modalService.open(BatchSummaryComponent);
            modalRef.componentInstance.errors = this.errors;
            modalRef.componentInstance.successes = this.successes;
          }
        });
    }
  }

  clearAll() {
    this.initSingleForm();
  }

  async fetchType() {
    this.type = [];
    this.typeLoading = true;
    let sort: SortObject[] = [{ prop: 'name', dir: 'asc' }];
    this.type = await this.lovApiService.getDropdownValues('budget', 'type', sort);
    this.typeLoading = false;
  }

  async fetchDepartment() {
    this.department = [];
    this.departmentLoading = true;
    let sort: SortObject[] = [{ prop: 'name', dir: 'asc' }];
    this.department = await this.lovApiService.getDropdownValues('budget', 'department', sort);
    this.departmentLoading = false;
  }

  getTags = (text: string): Observable<any> => {
    if (text.length > 0) {
      return this.budgetService.getTags(text.toLowerCase()).pipe(
        map((tagsSuggestion) =>
          tagsSuggestion.map((item: any) => {
            return item.value + ' (' + item.count + ')';
          })
        )
      );
    }
  };

  public transform(value): Observable<object> {
    let item;
    if (value?.display) {
      let formattedValue = value.display.split(' (')[0];
      item = { display: `${formattedValue}`, value: `${formattedValue}` };
    } else {
      item = { display: value, value: value };
    }
    return of(item);
  }

  checkValid() {
    this.form.markAsDirty();
    if(this.tags.length == 0) {
      this.disableForm = true;
      Object.keys(this.form.controls).forEach(key => {
        if (this.form.get(key).value !== null) {
          this.disableForm = false;
        }
      });
    }
  }

}
